module.exports = __webpack_public_path__ + "static/media/mini_insurance.aadf2d0f.svg";